import {SettingProvider} from "./SettingContext";
import {DataProvider} from "./DataContext";
import {Provider as Provider1} from "../pages/admin/context/Provider"
const Provider = ({children}) => {

    return (
        <Provider1>
            <DataProvider>
                <SettingProvider>
                    {children}
                </SettingProvider>
            </DataProvider>
        </Provider1>

    );
};

export default Provider;